import "./bootstrap";
import './index.css'
import { createApp } from "vue";

import mitt from "mitt";

window.eventBus = mitt();

// Libraries
import { VMaskDirective } from "v-slim-mask";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.css";
import { createI18n } from "vue-i18n";

// Custom plugins
import toaster from "./plugins/toaster";

import moment from "moment";
import icon from "./icons";
import trans from "./trans";
import Client from "./client";

import registerComponents from "./components";

import globalMixin from "./mixins/global";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
const app = createApp({});

const messages = {
    en: require("./locales/en.json"),
    es: require("./locales/es.json"),
};

const i18n = createI18n({
    locale: "es", // set locale
    fallbackLocale: "es", // set fallback locale
    messages, // set locale messages
});
app.directive("click-outside", {
    beforeMount(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            const callback = binding.value;

            if (typeof callback !== "function") {
                return;
            }

            if (!(el === event.target || el.contains(event.target))) {
                binding.value(event, el);
            }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
    },
    unmounted(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
    },
});

app.use(VueSweetalert2, {});

app.use(i18n);

// Uses
app.use(toaster, {
    closeButton: true,
});

// Mixins
app.mixin(globalMixin);

// Directives
app.directive("mask", VMaskDirective);

// Global properties to vim
app.config.globalProperties.$api = Client.instance();
app.config.globalProperties.$icon = icon;
app.config.globalProperties.$trans = trans;
app.config.globalProperties.moment = moment;

registerComponents(app);

app.mount("#app");
